import React, { Component } from "react";
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import '../Styles/Aside.css';

export default class Aside extends Component {
  render() {
    return (
      <aside className="media-links">
        <ul>
          <li>
            <a
              className="media-icon"
              href="https://github.com/h3zord"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub />
            </a>
          </li>
          <li>
            <a
              className="media-icon"
              href="https://www.linkedin.com/in/lucaschavarem/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin />
            </a>
          </li>
        </ul>
        <div className="empty-line"/>
      </aside>
    )
  }
}